import { initialFormValues } from './InitialFormValues';
import {
    MEMBER_DETAILS,
    NO_MEMBER_FOUND,
    DISABLE_NEXT,
    SET_INTEGRATION_TYPE,
    SET_RX_TOGGLE,
    SET_SOURCE_SYSTEM,
    SET_ESTIMATE_RESPONSE,
    SET_SINGLE_ESTIMATE_RESPONSE,
    SET_ALL_PROVIDERS_POOL,
    SET_CPTT_CORRELATION_ID,
    UPDATE_SHOW_ERROR_PAGE_VALUE,
    UPDATE_FORM_VALUE_CUSTOM,
    INCREMENT_SEARCH_COUNT,
    SET_PLAN_BENEFITS,
    SET_PREVENTIVE_ESTIMATE,
    SET_DIAGNOSTIC_ESTIMATE,
    TOGGLE_IS_PREVENTIVE,
    CLEAR_ESTIMATE_HISTORY,
    SET_ESTIMATE_PARAMETERS,
    CLEAR_PREVENTIVE_FLAGS,
    SET_RENTAL_ESTIMATES,
    SET_PURCHASE_ESTIMATES,
    SET_ESTIMATE_RESULTS_PAGE,
    SET_VISION_ESTIMATE_RESPONSE,
} from './actionTypes';
import { ESTIMATE_HISTORY_TYPES } from '../constants/index';

/*
 * Handles changes of state based on each action.type, called via dispatch
 * @param state {Object}: contains state variables defined in FormContext
 * @param action {Object}: contains action.type = action and action.name = fieldName
 * @returns {Array} the options to render
 */
export function reducer(state, action) {
    switch (action.type) {
        case 'reset':
            let saveDefaultDOB = null;
            if (
                state.formValues.defaultDateOfBirth.value &&
                state.formValues.defaultDateOfBirth.value != ''
            ) {
                saveDefaultDOB = state.formValues.defaultDateOfBirth;
            }
            let resetFormValues = { ...initialFormValues };
            if (saveDefaultDOB) {
                resetFormValues.defaultDateOfBirth = saveDefaultDOB;
            }
            return {
                ...state,
                activeStep: 0,
                formValues: resetFormValues,
                memberDetails: {},
            };
        case 'reset-form':
            return {
                ...state,
                formValues: { ...initialFormValues },
            };
        case 'form-value':
            return {
                ...state,
                noMemberFound: false,
                formValues: {
                    ...state.formValues,
                    [action.name]: {
                        ...state.formValues[action.name],
                        value: action.fieldValue,
                    },
                },
            };
        case 'form-error':
            return {
                ...state,
                formValues: {
                    ...state.formValues,
                    [action.name]: {
                        ...state.formValues[action.name],
                        error: action.error,
                    },
                },
            };
        case UPDATE_FORM_VALUE_CUSTOM:
            return {
                ...state,
                noMemberFound: false,
                formValues: {
                    ...state.formValues,
                    [action.name]: {
                        ...state.formValues[action.name],
                        [action.keyName]: action.fieldValue,
                    },
                },
            };
        case MEMBER_DETAILS:
            return {
                ...state,
                memberDetails: { ...action.body },
            };
        case SET_PLAN_BENEFITS:
            return {
                ...state,
                planBenefits: action.planBenefitInfo,
            };
        case NO_MEMBER_FOUND:
            return {
                ...state,
                noMemberFound: action.value,
            };
        case SET_CPTT_CORRELATION_ID:
            return {
                ...state,
                cpttCorrelationId: action.value,
            };
        case DISABLE_NEXT:
            return {
                ...state,
                disableNext: action.disable,
            };
        case SET_INTEGRATION_TYPE:
            return {
                ...state,
                integrationType: action.intType,
            };
        case SET_RX_TOGGLE:
            return {
                ...state,
                rxToggle: action.rxToggle,
            };
        case SET_SOURCE_SYSTEM:
            return {
                ...state,
                sourceSystem: action.system,
            };
        case SET_ESTIMATE_RESPONSE:
            return {
                ...state,
                estimateResponse: action.estimateResponse,
            };
        case SET_SINGLE_ESTIMATE_RESPONSE:
            return {
                ...state,
                singleEstimateResponse: action.singleEstimateResponse,
            };
        case SET_VISION_ESTIMATE_RESPONSE:
            return {
                ...state,
                visionEstimateResponse: action.visionEstimateResponse,
            };
        case SET_ALL_PROVIDERS_POOL:
            return {
                ...state,
                allProvidersPool: action.allProvidersPool,
            };
        case UPDATE_SHOW_ERROR_PAGE_VALUE:
            return {
                ...state,
                showErrorPage: action.payload,
            };
        case INCREMENT_SEARCH_COUNT:
            return {
                ...state,
                searchCount: state.searchCount + 1,
            };
        case SET_PREVENTIVE_ESTIMATE:
            return {
                ...state,
                estimatesHistory: {
                    ...state.estimatesHistory,
                    [ESTIMATE_HISTORY_TYPES.preventive]: {
                        singleEstimate:
                            action.singleEstimateResponse ??
                            state.estimatesHistory[ESTIMATE_HISTORY_TYPES.preventive]
                                .singleEstimate,
                        multipleEstimate:
                            action.multipleEstimateResponse ??
                            state.estimatesHistory[ESTIMATE_HISTORY_TYPES.preventive]
                                .multipleEstimate,
                    },
                },
            };
        case SET_DIAGNOSTIC_ESTIMATE:
            return {
                ...state,
                estimatesHistory: {
                    ...state.estimatesHistory,
                    [ESTIMATE_HISTORY_TYPES.diagnostic]: {
                        singleEstimate:
                            action.singleEstimateResponse ??
                            state.estimatesHistory[ESTIMATE_HISTORY_TYPES.diagnostic]
                                .singleEstimate,
                        multipleEstimate:
                            action.multipleEstimateResponse ??
                            state.estimatesHistory[ESTIMATE_HISTORY_TYPES.diagnostic]
                                .multipleEstimate,
                    },
                },
            };
        case TOGGLE_IS_PREVENTIVE:
            return {
                ...state,
                isPreventive: !state.isPreventive,
            };
        case CLEAR_ESTIMATE_HISTORY:
            return {
                ...state,
                estimatesHistory: {
                    ...state.estimatesHistory,
                    [ESTIMATE_HISTORY_TYPES.preventive]: {
                        singleEstimate: null,
                        multipleEstimate: null,
                    },
                    [ESTIMATE_HISTORY_TYPES.diagnostic]: {
                        singleEstimate: null,
                        multipleEstimate: null,
                    },
                    [ESTIMATE_HISTORY_TYPES.rental]: {
                        singleEstimate: null,
                        multipleEstimate: null,
                    },
                    [ESTIMATE_HISTORY_TYPES.purchase]: {
                        singleEstimate: null,
                        multipleEstimate: null,
                    },
                },
            };
        case SET_ESTIMATE_PARAMETERS:
            return {
                ...state,
                estimateParameters: {
                    allProviders: action.payload.allProviders,
                    oon: action.payload.oon,
                    gacOnly: action.payload.gacOnly,
                },
            };
        case CLEAR_PREVENTIVE_FLAGS:
            return {
                ...state,
                isPreventive: false,
            };
        case SET_PURCHASE_ESTIMATES:
            return {
                ...state,
                estimatesHistory: {
                    ...state.estimatesHistory,
                    [ESTIMATE_HISTORY_TYPES.purchase]: {
                        singleEstimate:
                            action.singleEstimateResponse ??
                            state.estimatesHistory[ESTIMATE_HISTORY_TYPES.purchase].singleEstimate,
                        multipleEstimate:
                            action.multipleEstimateResponse ??
                            state.estimatesHistory[ESTIMATE_HISTORY_TYPES.purchase]
                                .multipleEstimate,
                    },
                },
            };
        case SET_RENTAL_ESTIMATES:
            return {
                ...state,
                estimatesHistory: {
                    ...state.estimatesHistory,
                    [ESTIMATE_HISTORY_TYPES.rental]: {
                        singleEstimate:
                            action.singleEstimateResponse ??
                            state.estimatesHistory[ESTIMATE_HISTORY_TYPES.rental].singleEstimate,
                        multipleEstimate:
                            action.multipleEstimateResponse ??
                            state.estimatesHistory[ESTIMATE_HISTORY_TYPES.rental].multipleEstimate,
                    },
                },
            };
        case SET_ESTIMATE_RESULTS_PAGE:
            return {
                ...state,
                estimateResultsPage: action.value,
            };

        default:
            return state;
    }
}
